const origin = window.location.origin;

export const oauth = {
  domain: "business-prodyt.auth.ap-south-1.amazoncognito.com",
  scope: ["email", "openid", "profile"],

  // must match Cognito callback URLs EXACTLY
  redirectSignIn: `${origin}/auth/callback`,

  // must match Cognito signout URLs EXACTLY
  redirectSignOut: `${origin}/`,
  responseType: "code"
};